module.exports = new __parcel__URL__("webLinkIcon.91379809.svg").toString();